import { createApp } from 'vue'
import App from './App.vue'

import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'

import { createPinia } from 'pinia'
import { getId } from '@/stores/token'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHouse, faQrcode, faList, faLightbulb } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHouse, faQrcode, faList, faLightbulb, faHouse)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)

const router = createRouter({
  history: createWebHistory(),
  routes
})

const pinia = createPinia()
app.use(pinia)
app.use(router)

router.beforeEach((to, from, next) => {
  const idStore = getId()
  idStore.initUserFromCookie()

  const isAuthenticated = !!idStore.userId

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/auth')
  } else if (!to.meta.requiresAuth && isAuthenticated && to.path.startsWith('/auth')) {
    next('/')
  } else {
    next()
  }
})

app.mount('#app')